import React from "react"
import moment from "moment"
import ReusableComponent from "./ResuableComponent"
import ReusableComponent2 from "./Method"

const L1Report = ({ report1, track, setLoading, setSubmit }) => {
  if (!report1 || report1.length === 0) {
    return <div className="text-center">Leave Authority Report 1 not available</div>
  }

  return (
    <>
      {report1.map((item, index) => (
        <div
          key={index}
          style={{
            backgroundColor: "#fff",
            borderRadius: "4px",
            marginTop: "5px",
            padding: "10px",
            position: "relative",
          }}
        >
          <div className="d-flex p-3 border rounded shadow-sm flex-column">
            <ReusableComponent title={"Name"} value={item.name} />
            <ReusableComponent title={"Leave"} value={item.leave_category} />
            <ReusableComponent
              title={"Applied Dt"}
              value={moment(item.leave_start).format("DD-MM-YYYY")}
            />
            <ReusableComponent
              title={"Leave Start"}
              value={moment(item.leave_start).format("DD-MM-YYYY")}
            />
            <ReusableComponent
              title={"Leave End"}
              value={moment(item.leave_end).format("DD-MM-YYYY")}
            />
            <ReusableComponent
              title={"From Session"}
              value={`Session ${item.from_session}`}
            />
            <ReusableComponent
              title={"To Session"}
              value={`Session ${item.to_session}`}
            />
            <ReusableComponent
              title={"No. Leaves Apply"}
              value={item.leave_count}
            />
            <ReusableComponent title={"Leave Reason"} value={item.reason} />
            <ReusableComponent
              title={"Status Reason"}
              value={item.leave_reason}
            />
            <ReusableComponent2
              id={item.req_id}
              title={"Status"}
              value={item.req_status}
              track={track}
              setLoading={setLoading}
              setSubmit={setSubmit}
            />
            <ReusableComponent title={"File"} value={item.filename} />
          </div>
        </div>
      ))}
    </>
  )
}

export default L1Report
